import { Component, EventEmitter, Injector, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { STComponent } from '@delon/abc/st';
import { ArrayService } from '@delon/util';
import { STComponentBase } from '@shared/itcore/components/st-component-base';
import { FilterGroup, FilterOperate, FilterRule, PageRequest } from '@shared/itcore/itcore.model';
import { ItcoreSTColumn } from '@shared/itcore/services/alain.types';
import { itcoreService } from '@shared/itcore/services/itcore.service';
// tslint:disable-next-line: import-blacklist
export interface TreeNodeInterface {
  Id: string;
  DepartmentName: string;
  level: number;
  expand: boolean;
  children?: TreeNodeInterface[];
}

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'sedepartment-view',
  template: `
      <div class="scrollable-container" >
      <nz-card>
        <nz-table #nzTable [nzData]="data" nzSize="small">
          <thead>
            <tr>
              <th style="width: 50px;">操作</th>
              <th>部门名称</th>
              <th>是否锁定</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let data of nzTable.data">
              <ng-container *ngFor="let item of mapOfExpandedData[data.Id]">
                <tr *ngIf="(item.parent && item.parent.expand) || !item.parent">
                  <td><label nz-checkbox [(ngModel)]="item.IsCurrentDep" (ngModelChange)="SelectChange(item)"></label></td>
                  <td
                    [nzIndentSize]="item.level * 20"
                    [nzShowExpand]="!!item.children && item.children.length > 0"
                    [(nzExpand)]="item.expand"
                    (nzExpandChange)="collapse(mapOfExpandedData[data.Id], item, $event)"
                  >
                    {{ item.DepartmentName }}
                  </td>
                  <td>
                      <nz-tag *ngIf="item.IsLocked" [nzColor]="'#f50'">是</nz-tag>
                      <nz-tag *ngIf="!item.IsLocked" [nzColor]="'#2db7f5'">否</nz-tag>
                  </td>
                </tr>
              </ng-container>
            </ng-container>
          </tbody>
        </nz-table>
      </nz-card>
      </div>
      <div style="margin-top: 10px;text-align: center;">
        <button nz-button (click)="SaveData()" [nzType]="reload"><i nz-icon></i>保存</button>
        <button nz-button (click)="loadData()" [nzType]="reload"><i nz-icon nzType="reload" theme="outline"></i>刷新</button>
      </div>
  `,
  styles: [
    `
      .scrollable-container {
        height: 800px;
        overflow-y: scroll;
      }
    `,
  ],
})
export class SeDepartmentViewComponent implements OnInit {
  constructor(injector: Injector, private arraySrv: ArrayService) {
    this.itcore = injector.get(itcoreService);
  }
  itcore: itcoreService;

  data = [];
  department = [];
  depArry: any[];
  request: PageRequest = new PageRequest();
  mapOfExpandedData: { [key: string]: TreeNodeInterface[] } = {};
  UserId: number; // 用户编号
  cusDepartment: any[] = [];
  ngOnInit(): void { }

  loadData() {
    this.cusDepartment = [];
    this.itcore.http.post('api/admin/Department/read?UserId=' + this.UserId, { UserId: this.UserId }).subscribe((res) => {
      const tree = this.arraySrv.arrToTree(res, { idMapName: 'Id', parentIdMapName: 'tParent' });
      this.data = tree;
      res.forEach((x) => {
        if (x.IsCurrentDep === true) {
          this.cusDepartment.push({ DepartmentId: x.Id, UserId: this.UserId });
        }
      });
      tree.forEach((item) => (this.mapOfExpandedData[item.Id] = this.convertTreeToList(item)));
      this.depArry = this.arraySrv.treeToArr(tree);
    });
  }

  collapse(array: TreeNodeInterface[], data: TreeNodeInterface, $event: boolean): void {
    if ($event === false) {
      if (data.children) {
        data.children.forEach((d) => {
          // tslint:disable-next-line: no-non-null-assertion
          const target = array.find((a) => a.Id === d.Id)!;
          target.expand = false;
          this.collapse(array, target, false);
        });
      } else {
        return;
      }
    }
  }

  convertTreeToList(root: object): TreeNodeInterface[] {
    const stack: any[] = [];
    const array: any[] = [];
    const hashMap = {};
    stack.push({ ...root, level: 0, expand: true });

    while (stack.length !== 0) {
      const node = stack.pop();
      this.visitNode(node, hashMap, array);
      if (node.children) {
        for (let i = node.children.length - 1; i >= 0; i--) {
          stack.push({ ...node.children[i], level: node.level + 1, expand: true, parent: node });
        }
      }
    }

    return array;
  }

  visitNode(node: TreeNodeInterface, hashMap: { [key: number]: any }, array: TreeNodeInterface[]): void {
    if (!hashMap[node.Id]) {
      hashMap[node.Id] = true;
      array.push(node);
    }
  }

  reload(userId: number) {
    this.UserId = userId;
    this.loadData();
  }

  SelectChange(item: any) {
    // 选中
    if (item.IsCurrentDep === true) {
      this.cusDepartment.push({ DepartmentId: item.Id, UserId: this.UserId });
    } else {
      this.cusDepartment = this.cusDepartment.filter((x) => {
        return x.DepartmentId !== item.Id;
      });
    }
  }

  SaveData() {
    this.itcore.http.post('api/admin/UserDepartment/Create', this.cusDepartment).subscribe((res) => {
      if (res.Type === 200) {
        this.itcore.msgSrv.create('success', `保存成功！`);
        this.loadData();
      }
    });
  }
}
